var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import HttpStatus from "http-status-codes";
import { call, put, takeEvery, takeLatest, takeLeading, } from "redux-saga/effects";
import logger from "../../logger";
// import * as loggerTypes from "../../logger/logger.types";
// import * as contactActions from "../../redux/contact/contact.actions";
// import { updateContact } from "../../redux/contact/contact.api";
// import { EContactCustomId } from "../../redux/contact/contact.types";
import { getUser, signUpVerifiedEmail } from "../../redux/auth/auth.actions";
import * as socketActions from "../../redux/socket/socket.actions";
// import { IUser } from "../../types/auth.types";
// import { IContact } from "../../types/contact.types";
import { showAlert } from "../../utils/alert/alert.utils";
import { cancelPendingCalls } from "../../utils/api/api.utils";
import { 
// getGeneralUpdateSuccessText,
getLocalizedText, } from "../../utils/i18n/i18n.utils";
import { signInStart, signInSucceeded, signInFailed, signInAutomaticallyStart, signInAutomaticallySucceeded, signInAutomaticallyFailed, setAccessTokensWithoutSideEffectsStart, signOutStart, setBypassToken, 
// signUpStart,
// signUpSucceeded,
// signUpFailed,
// signUpVerifyPhoneStart,
signUpVerifyPhoneSucceeded, 
// signUpVerifyPhoneFailed,
// signUpVerifyEmailStart,
signUpRequestTokenFromEmailStart, signUpRequestTokenFromEmailSucceeded, signUpRequestTokenFromEmailFailed,
// signUpResendVerificationEmailStart,
// signUpResendVerificationSmsStart,
// getUserStart,
// getUserSucceeded,
// getUserFailed,
// updateUserStart,
// updateUserSucceeded,
// updateUserFailed,
// updateUserByIdStart,
// updateUserByIdSucceeded,
// updateUserByIdFailed,
// removeProfileStart,
// removeProfileSucceeded,
// removeProfileFailed,
// adminVerifyEmailStart,
// adminVerifyEmailSucceeded,
// adminVerifyEmailFailed,
// adminVerifyPhoneStart,
// adminVerifyPhoneSucceeded,
// adminVerifyPhoneFailed,
 } from "./auth.actions";
import * as authApi from "./auth.api";
// import * as authSelectors from "./auth.selectors";
import * as authUtils from "./auth.utils";
function signOutFlow() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(authUtils.setAccessToken, undefined)];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, undefined)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(logger.clearValues)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function setBypassTokenFlow(action) {
    var payload, bypassToken, unknownError_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                bypassToken = payload.bypassToken;
                return [4 /*yield*/, call(authUtils.setBypassToken, bypassToken)];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                unknownError_1 = _a.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
function signInStartFlow(action) {
    var _a, phoneOrEmail, password, data, _b, accessToken, refreshToken, userType, userId, userTypePreference, unknownError_2, error, errorMessage, content, axiosError;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = action.payload, phoneOrEmail = _a.phoneOrEmail, password = _a.password;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(authApi.signIn, {
                        emailOrPhone: phoneOrEmail,
                        password: password,
                    })];
            case 2:
                data = _d.sent();
                _b = data, accessToken = _b.accessToken, refreshToken = _b.refreshToken, userType = _b.userType, userId = _b.userId;
                return [4 /*yield*/, call(authUtils.getUserType, userId)];
            case 3:
                userTypePreference = _d.sent();
                return [4 /*yield*/, put(signInSucceeded.getAction({
                        accessToken: accessToken,
                        refreshToken: refreshToken,
                        // @ts-ignore
                        userType: userTypePreference || userType,
                        selectedDashboardType: authUtils.getDashboardPreference(userTypePreference, userType),
                    }))];
            case 4:
                _d.sent();
                return [3 /*break*/, 7];
            case 5:
                unknownError_2 = _d.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(signInFailed.getAction({
                        error: error,
                    }))];
            case 6:
                _d.sent();
                errorMessage = getLocalizedText("general.error");
                content = undefined;
                axiosError = error;
                if (axiosError.isAxiosError) {
                    switch ((_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.status) {
                        case HttpStatus.BAD_REQUEST:
                            errorMessage = getLocalizedText("system.wrong.password");
                            break;
                        case HttpStatus.PAYMENT_REQUIRED:
                            errorMessage = getLocalizedText("auth.sign_in.error.payment_required.title");
                            content = getLocalizedText("auth.sign_in.error.payment_required.content");
                            break;
                        default:
                            break;
                    }
                }
                showAlert({
                    type: "error",
                    message: errorMessage,
                    content: content,
                });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function signInAutomaticallyStartFlow(action) {
    var token, data, _a, accessToken, refreshToken, userType, userId, userTypePreference, unknownError_3, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                token = action.payload.token;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(authApi.signInAutomatically, token)];
            case 2:
                data = _b.sent();
                _a = data, accessToken = _a.accessToken, refreshToken = _a.refreshToken, userType = _a.userType, userId = _a.userId;
                return [4 /*yield*/, call(authUtils.getUserType, userId)];
            case 3:
                userTypePreference = _b.sent();
                return [4 /*yield*/, put(signInAutomaticallySucceeded.getAction({
                        accessToken: accessToken,
                        refreshToken: refreshToken,
                        // @ts-ignore
                        userType: userTypePreference || userType,
                        selectedDashboardType: authUtils.getDashboardPreference(userTypePreference, userType),
                    }))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                unknownError_3 = _b.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                return [4 /*yield*/, put(signInAutomaticallyFailed.getAction({ error: error }))];
            case 6:
                _b.sent();
                showAlert({
                    type: "error",
                    message: error.message,
                });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function setAccessTokensWithoutSideEffectsFlow(action) {
    var _a, accessToken, refreshToken, unknownError_4, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, accessToken = _a.accessToken, refreshToken = _a.refreshToken;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                cancelPendingCalls();
                return [4 /*yield*/, call(authUtils.setAccessToken, accessToken)];
            case 2:
                _b.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, refreshToken)];
            case 3:
                _b.sent();
                return [3 /*break*/, 5];
            case 4:
                unknownError_4 = _b.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function genericSignInSuccessFlow(action) {
    var _a, accessToken, refreshToken, unknownError_5, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 7]);
                _a = action.payload, accessToken = _a.accessToken, refreshToken = _a.refreshToken;
                cancelPendingCalls();
                return [4 /*yield*/, call(authUtils.setAccessToken, accessToken)];
            case 1:
                _b.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, refreshToken)];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(socketActions.openSocket.actions.start({}))];
            case 3:
                _b.sent();
                // yield put(getUserStart.getAction({}));
                return [4 /*yield*/, put(getUser.actions.start({}))];
            case 4:
                // yield put(getUserStart.getAction({}));
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                unknownError_5 = _b.sent();
                error = unknownError_5;
                logger.logError({ error: error });
                return [4 /*yield*/, put(signInAutomaticallyFailed.getAction({ error: error }))];
            case 6:
                _b.sent();
                showAlert({
                    type: "error",
                    message: error.message,
                });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
// function* rehydrateFlow(action: { type: string; key: string }) {
//   try {
//     const { key } = action;
//     if (key !== "auth") {
//       return;
//     }
//     const user = authSelectors.getUser(yield select());
//     if (user) {
//       logger.setValue({
//         type: loggerTypes.EValueType.UserEmail,
//         value: user.email || "",
//       });
//     }
//     const hasAccessToken = authSelectors.hasAccessToken(yield select());
//     if (hasAccessToken) {
//       yield put(socketActions.openSocket.actions.start({}));
//     }
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//   }
// }
// function* signUpStartFlow(action: typeof signUpStart.actionType) {
//   const {
//     locale,
//     platform,
//     firstname,
//     lastname,
//     email,
//     phone,
//     password,
//     captcha,
//     captchaVersion,
//     role,
//   } = action.payload;
//   try {
//     const { data: tac } = yield call(authApi.getTac, locale, platform);
//     const { data: user } = yield call(authApi.signUp, {
//       locale,
//       tacId: tac.id,
//       firstname,
//       lastname,
//       unverifiedPhone: phone,
//       unverifiedEmail: email,
//       password,
//       captcha,
//       captchaVersion,
//     });
//     yield put(signUpSucceeded.getAction({ user }));
//     yield call(authUtils.setUserType, user.id, role);
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     yield put(signUpFailed.getAction({ error }));
//     showAlert({
//       type: "error",
//       error,
//     });
//   }
// }
// function* signUpVerifyPhoneStartFlow(
//   action: typeof signUpVerifyPhoneStart.actionType,
// ) {
//   const { code } = action.payload;
//   try {
//     const user = authSelectors.getUser(yield select());
//     if (!user) {
//       throw new Error("No user");
//     }
//     const { status, data } = yield call(authApi.verifyPhone, user.id, code);
//     if (status === HttpStatus.NO_CONTENT) {
//       yield put(
//         signUpVerifyPhoneFailed.getAction({
//           error: new Error("Wrong code"),
//         }),
//       );
//       showAlert({
//         type: "error",
//         message: getLocalizedText("intake.verification.pincode.wrong"),
//       });
//       return;
//     }
//     const { accessToken, refreshToken } = data;
//     yield put(
//       signUpVerifyPhoneSucceeded.getAction({
//         accessToken,
//         refreshToken,
//       }),
//     );
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     yield put(signUpVerifyPhoneFailed.getAction({ error }));
//     showAlert({
//       type: "error",
//       error,
//     });
//   }
// }
function signUpRequestTokenFromEmailStartFlow(action) {
    var _a, userId, token, onSuccess, onFailure, error, response, _b, accessToken, refreshToken, unknownError_6, error, axiosError;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = action.payload, userId = _a.userId, token = _a.token, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                if (!!token) return [3 /*break*/, 2];
                error = new Error("No unverified email request token");
                return [4 /*yield*/, put(signUpRequestTokenFromEmailFailed.getAction({ error: error }))];
            case 1:
                _d.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                showAlert({
                    type: "error",
                    message: getLocalizedText("profile.email.unverified"),
                });
                return [2 /*return*/];
            case 2:
                _d.trys.push([2, 9, , 11]);
                return [4 /*yield*/, call(authApi.getAccessTokenFromEmail, userId, token)];
            case 3:
                response = _d.sent();
                _b = response.data.data, accessToken = _b.accessToken, refreshToken = _b.refreshToken;
                return [4 /*yield*/, call(authUtils.setAccessToken, accessToken)];
            case 4:
                _d.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, refreshToken)];
            case 5:
                _d.sent();
                // Flips hasAccessToken so withAuthenticationCheck lets the user through after the
                // redirect. Nothing else listens to it: genericSignInSuccessFlow is not subscribed.
                return [4 /*yield*/, put(signUpVerifyPhoneSucceeded.getAction({ accessToken: accessToken, refreshToken: refreshToken }))];
            case 6:
                // Flips hasAccessToken so withAuthenticationCheck lets the user through after the
                // redirect. Nothing else listens to it: genericSignInSuccessFlow is not subscribed.
                _d.sent();
                return [4 /*yield*/, put(signUpRequestTokenFromEmailSucceeded.getAction({}))];
            case 7:
                _d.sent();
                // The web apps keep the user in the v1 slice, so hydrate it through the same flow
                // the screen dispatches once a session already exists.
                return [4 /*yield*/, put(signUpVerifiedEmail())];
            case 8:
                // The web apps keep the user in the v1 slice, so hydrate it through the same flow
                // the screen dispatches once a session already exists.
                _d.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 11];
            case 9:
                unknownError_6 = _d.sent();
                error = unknownError_6;
                logger.logError({ error: error });
                return [4 /*yield*/, put(signUpRequestTokenFromEmailFailed.getAction({ error: error }))];
            case 10:
                _d.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                axiosError = error;
                if (axiosError.isAxiosError &&
                    ((_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.status) === HttpStatus.FORBIDDEN) {
                    showAlert({
                        type: "error",
                        message: getLocalizedText("profile.email.unverified"),
                    });
                    return [2 /*return*/];
                }
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
// function* signUpVerifiedEmailStartFlow() {
//   try {
//     const { data: user } = yield call(authApi.getUser);
//     yield put(getUserSucceeded.getAction(user));
//     logger.setValue({
//       type: loggerTypes.EValueType.UserEmail,
//       value: user.email || "",
//     });
//     if (user.unverifiedEmail) {
//       showAlert({
//         type: "error",
//         message: getLocalizedText("profile.email.unverified"),
//       });
//     }
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     showAlert({
//       type: "error",
//       error,
//     });
//   }
// }
// function* signUpResendVerificationEmailStartFlow() {
//   try {
//     const user = authSelectors.getUser(yield select());
//     if (!user) {
//       throw new Error("No user");
//     }
//     if (!user.unverifiedEmail) {
//       throw new Error("No unverified email");
//     }
//     yield call(authApi.resendVerificationEmail, user.unverifiedEmail);
//     showAlert({
//       type: "info",
//       message: getLocalizedText("verify_email.info.description", {
//         email: user.unverifiedEmail,
//       }),
//     });
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     showAlert({
//       type: "error",
//       error,
//     });
//   }
// }
// function* signUpResendVerificationSmsStartFlow() {
//   try {
//     const user = authSelectors.getUser(yield select());
//     if (!user) {
//       throw new Error("No user");
//     }
//     if (!user.unverifiedPhone) {
//       throw new Error("No unverified phone");
//     }
//     yield call(authApi.resendVerificationSms, user.unverifiedPhone);
//     showAlert({
//       type: "info",
//       message: getLocalizedText("verify_sms.info.description", {
//         phone: user.unverifiedPhone,
//       }),
//     });
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     showAlert({
//       type: "error",
//       error,
//     });
//   }
// }
// function* getUserStartFlow(action: typeof getUserStart.actionType) {
//   try {
//     const { data: user } = yield call(authApi.getUser);
//     yield put(getUserSucceeded.getAction(user));
//     logger.setValue({
//       type: loggerTypes.EValueType.UserEmail,
//       value: user.email || "",
//     });
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     yield put(getUserFailed.getAction({ error }));
//   }
// }
// function* updateUserStartFlow(action: typeof updateUserStart.actionType) {
//   const { user, contact, onSuccess } = action.payload;
//   try {
//     if (contact?.id) {
//       const { data: updatedContact }: AxiosResponse<IContact> = yield call(
//         updateContact,
//         contact.id,
//         contact,
//       );
//       yield put(
//         contactActions.updateContact.actions.success({
//           contactId: updatedContact.id,
//           contact: updatedContact,
//         }),
//       );
//     }
//     const { data: updatedUser }: AxiosResponse<IUser> = yield call(
//       authApi.updateUser,
//       user,
//     );
//     yield put(
//       updateUserSucceeded.getAction({
//         user: updatedUser,
//       }),
//     );
//     yield put(
//       contactActions.getContact.actions.start({
//         contactId: EContactCustomId.MeMaster,
//       }),
//     );
//     yield put(
//       contactActions.getContact.actions.start({
//         contactId: EContactCustomId.Me,
//       }),
//     );
//     onSuccess?.(updatedUser);
//     showAlert({
//       type: "success",
//       message: getGeneralUpdateSuccessText("user"),
//     });
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     yield put(updateUserFailed.getAction({ error }));
//   }
// }
// function* updateUserByIdStartFlow(
//   action: typeof updateUserByIdStart.actionType,
// ) {
//   const { id, user, onSuccess } = action.payload;
//   try {
//     const { data: updatedUser }: AxiosResponse<IUser> = yield call(
//       authApi.updateUserById,
//       id,
//       user,
//     );
//     yield put(
//       updateUserByIdSucceeded.getAction({
//         id,
//         user: updatedUser,
//       }),
//     );
//     onSuccess?.(updatedUser);
//     showAlert({
//       type: "success",
//       message: getGeneralUpdateSuccessText("user"),
//     });
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     yield put(updateUserByIdFailed.getAction({ id, error }));
//   }
// }
// function* removeProfileStartFlow(action: typeof removeProfileStart.actionType) {
//   const { onSuccess } = action.payload;
//   try {
//     yield call(authApi.removeProfile);
//     yield put(removeProfileSucceeded.getAction({}));
//     onSuccess?.();
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     yield put(removeProfileFailed.getAction({ error }));
//   }
// }
// function* adminVerifyEmailStartFlow(
//   action: typeof adminVerifyEmailStart.actionType,
// ) {
//   const { userId } = action.payload;
//   try {
//     const { data } = yield call(authApi.adminVerifyEmail, userId);
//     yield put(adminVerifyEmailSucceeded.getAction(data));
//     showAlert({
//       type: "success",
//       message: getGeneralUpdateSuccessText("user"),
//     });
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     yield put(adminVerifyEmailFailed.getAction({ error }));
//     showAlert({
//       type: "error",
//       error,
//     });
//   }
// }
// function* adminVerifyPhoneStartFlow(
//   action: typeof adminVerifyPhoneStart.actionType,
// ) {
//   const { userId } = action.payload;
//   try {
//     const { data } = yield call(authApi.adminVerifyPhone, userId);
//     yield put(adminVerifyPhoneSucceeded.getAction(data));
//     showAlert({
//       type: "success",
//       message: getGeneralUpdateSuccessText("user"),
//     });
//   } catch (unknownError) {
//     const error = unknownError as any;
//     logger.logError({ error });
//     yield put(adminVerifyPhoneFailed.getAction({ error }));
//     showAlert({
//       type: "error",
//       error,
//     });
//   }
// }
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(signOutStart.type, signOutFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(setBypassToken.getType(), setBypassTokenFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(signInStart.type, signInStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(signInAutomaticallyStart.type, signInAutomaticallyStartFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(setAccessTokensWithoutSideEffectsStart.type, setAccessTokensWithoutSideEffectsFlow)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest([
                        signInSucceeded.type,
                        signInAutomaticallySucceeded.type,
                        // signUpVerifyPhoneSucceeded.type,
                    ], genericSignInSuccessFlow)];
            case 6:
                _a.sent();
                // yield takeLatest(signUpStart.type, signUpStartFlow);
                // yield takeLatest(signUpVerifyPhoneStart.type, signUpVerifyPhoneStartFlow);
                // yield takeLatest(signUpVerifyEmailStart.type, signUpVerifiedEmailStartFlow);
                // takeLeading, not takeLatest: the token is single-use, so a second click would cancel
                // the saga holding the session the first request minted and get a 403 of its own.
                return [4 /*yield*/, takeLeading(signUpRequestTokenFromEmailStart.type, signUpRequestTokenFromEmailStartFlow)];
            case 7:
                // yield takeLatest(signUpStart.type, signUpStartFlow);
                // yield takeLatest(signUpVerifyPhoneStart.type, signUpVerifyPhoneStartFlow);
                // yield takeLatest(signUpVerifyEmailStart.type, signUpVerifiedEmailStartFlow);
                // takeLeading, not takeLatest: the token is single-use, so a second click would cancel
                // the saga holding the session the first request minted and get a 403 of its own.
                _a.sent();
                return [2 /*return*/];
        }
    });
}
